// extracted by mini-css-extract-plugin
module.exports = {"incidentDetailRight":"IncidentDetailsRight_incidentDetailRight__2o7JF"};